import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSortModule } from '@angular/material/sort';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatTreeModule } from '@angular/material/tree';
import { MatRadioModule } from '@angular/material/radio';

import { MatChipsModule } from '@angular/material/chips';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
// import { FlexLayoutModule } from '@angular/flex-layout';

import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { DeleteDialogComponent } from './list/delete-dialog/delete-dialog.component';
import { EnumPipe } from '../../shared/enum.pipe';
import { FormControlNumberPlusLessComponent } from './edit/form-control/form-control-number-plus-less/form-control-number-plus-less.component';
import { FormControlTextComponent } from './edit/form-control/form-control-text/form-control-text.component';
import { FormControlPasswordComponent } from './edit/form-control/form-control-password/form-control-password.component';
import { FormControlSelectComponent } from './edit/form-control/form-control-select/form-control-select.component';
import { FormControlDateComponent } from './edit/form-control/form-control-date/form-control-date.component';
import { FormControlSlideToggleComponent } from './edit/form-control/form-control-slide-toggle/form-control-slide-toggle.component';
import { FormControlTextareaComponent } from './edit/form-control/form-control-textarea/form-control-textarea.component';
import { FormControlCheckboxlistComponent } from './edit/form-control/form-control-checkboxlist/form-control-checkboxlist.component';
import { FormControlSliderComponent } from './edit/form-control/form-control-slider/form-control-slider.component';
import { TranslateModule } from '@ngx-translate/core';
import { UnsavedDialogComponent } from './edit/unsaved-dialog/unsaved-dialog.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormcontrolbuttontoggleComponent } from './edit/form-control/form-control-button-toggle/form-control-button-toggle';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';
import { MatSliderModule } from '@angular/material/slider';
import { FilterSeparatorComponent } from './list/filter-separator/filter-separator.component';
import { HttpClientModule } from '@angular/common/http';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { LinkComponent } from './list/link/link.component';
import { RouterModule } from '@angular/router';
import { FormControlAutocompleteWithGroupComponent } from './edit/form-control/form-control-autocomplete-with-group/form-control-autocomplete-with-group';
import { FormControlHourComponent } from './edit/form-control/form-control-hour/form-control-hour.component';
import { FormControlTextColorPickerComponent } from './edit/form-control/form-control-text-color-picker/form-control-text-color-picker.component';
import { FormControlColorPickerComponent } from './edit/form-control/form-control-color-picker/form-control-color-picker.component';
import { FormControlAutocompleteWithGroupProductComponent } from './edit/form-control/form-control-autocomplete-with-group-product/form-control-autocomplete-with-group-product';
import { FormControlSelectWithGroupMultipleComponent } from './edit/form-control/form-control-select-with-group-multiple/form-control-select-with-group-multiple.component';
import { FormControlNotSignSinceComponent } from './edit/form-control/form-control-not-sign-since/form-control-not-sign-since.component';
import { FormControlDateRangeSelectorComponent } from './edit/form-control/form-control-date-range-selector/form-control-date-range-selector.component';

import { FormControlDiffusionSettingsComponent } from './edit/form-control/form-control-diffusion-settings/form-control-diffusion-settings.component';
import {
	DateAdapter,
	MAT_DATE_FORMATS,
	MAT_DATE_LOCALE,
	// SatDatepickerModule,
	// SatNativeDateModule,
} from 'saturn-datepicker-v15';
import { FormControlTreeSelectionShelfsComponent } from './edit/form-control/form-control-tree-selection-shelfs/form-control-tree-selection-shelfs.component';

import { FormControlCheckboxlistUserFaceComponent } from './edit/form-control/form-control-checkboxlist-user-face/form-control-checkboxlist-user-face.component';
import {LuxonDateAdapter, MAT_LUXON_DATE_FORMATS} from '@angular/material-luxon-adapter';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatTableModule,
        MatPaginatorModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        HttpClientModule,
        MatDialogModule,
        MatSortModule,
        MatSelectModule,
        MatRadioModule,
        MatDatepickerModule,
        MatSlideToggleModule,
        MatCheckboxModule,
        TranslateModule,
        MatProgressSpinnerModule,
        MatTooltipModule,
        MatButtonToggleModule,
        MatCardModule,
        MatDividerModule,
        MatListModule,
        MatSliderModule,
        MatTreeModule,
        ScrollingModule,
        RouterModule,
        MatAutocompleteModule,
        NgxMaterialTimepickerModule,
        // FlexLayoutModule,
        // SatDatepickerModule,
        // SatNativeDateModule,
    ],
    declarations: [
        DeleteDialogComponent,
        EnumPipe,
        UnsavedDialogComponent,
        FormControlTextComponent,
        FormControlPasswordComponent,
        FormControlSelectComponent,
        FormControlNumberPlusLessComponent,
        FormControlDateComponent,
        FormControlHourComponent,
        FormControlSlideToggleComponent,
        FormControlTextareaComponent,
        FormControlCheckboxlistComponent,
        FormcontrolbuttontoggleComponent,
        FormControlSliderComponent,
        FilterSeparatorComponent,
        LinkComponent,
        FormControlAutocompleteWithGroupComponent,
        FormControlTextColorPickerComponent,
        FormControlColorPickerComponent,
        FormControlAutocompleteWithGroupProductComponent,
        FormControlSelectWithGroupMultipleComponent,
        FormControlNotSignSinceComponent,
        FormControlDateRangeSelectorComponent,
        FormControlDiffusionSettingsComponent,
        FormControlTreeSelectionShelfsComponent,
        FormControlCheckboxlistUserFaceComponent,
    ],
    exports: [
        FormsModule,
        ReactiveFormsModule,
        MatTableModule,
        MatPaginatorModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatRadioModule,
        MatIconModule,
        HttpClientModule,
        MatDialogModule,
        MatSortModule,
        MatTreeModule,
        MatSlideToggleModule,
        FormControlTextComponent,
        FormControlHourComponent,
        FormControlPasswordComponent,
        FormControlSelectComponent,
        MatSelectModule,
        FormControlDateComponent,
        FormControlNumberPlusLessComponent,
        FormControlSlideToggleComponent,
        FormControlTextareaComponent,
        FormControlCheckboxlistComponent,
        FormControlCheckboxlistUserFaceComponent,
        MatProgressSpinnerModule,
        MatTooltipModule,
        MatChipsModule,
        FormcontrolbuttontoggleComponent,
        MatCardModule,
        MatDividerModule,
        MatListModule,
        MatDatepickerModule,
        MatSliderModule,
        FormControlSliderComponent,
        MatCheckboxModule,
        MatAutocompleteModule,
        FilterSeparatorComponent,
        ScrollingModule,
        LinkComponent,
        FormControlAutocompleteWithGroupComponent,
        FormControlTextColorPickerComponent,
        FormControlColorPickerComponent,
        FormControlAutocompleteWithGroupProductComponent,
        FormControlSelectWithGroupMultipleComponent,
        FormControlNotSignSinceComponent,
        FormControlDateRangeSelectorComponent,
        FormControlDiffusionSettingsComponent,
        FormControlTreeSelectionShelfsComponent,
    ],
    providers: [
        {
            provide: DateAdapter,
            useClass: LuxonDateAdapter,
            deps: [MAT_DATE_LOCALE],
        },
        { provide: MAT_DATE_FORMATS, useValue: MAT_LUXON_DATE_FORMATS },
    ]
})
export class CrudModule {}
